export default "__VITE_ASSET__CVfwXWok__"